import React, { useEffect, useState } from "react";
import { useTheme } from "../../hooks/useSingleton";
import _getFieldInstance from "../../utils/_getFieldInstance";
import { Button, ConfirmationModal, DialogContainer, Modal, ModalTitle, ModalTitleContainer, MoreHorizonButton } from "@factorearth/component-library";
import FieldHistory from "../FieldHistory/FieldHistory";
import { FieldInstance, FieldTemplate } from "db/definitions";
import { FiX } from "react-icons/fi";

interface Props {
	/**
	 * The username of the logged in user
	 */
	authUsername: string;
	currentFieldInstance: FieldInstance;
	fieldTemplate: FieldTemplate;
	handleRevert: (value: string) => void;
	handleUpdate: (fieldInstance: FieldInstance) => void;
	online: boolean;
	openFieldMenu: boolean;
	removeUser: () => Promise<void>;
	/**
	 * The username of the person editing the field
	 */
	username: string;
}

function FieldMenu(props: Props) {
	const { authUsername, currentFieldInstance, fieldTemplate, handleRevert, handleUpdate, online, openFieldMenu, removeUser, username } = props;

	const [openFieldHistory, setOpenFieldHistory] = useState(false);
	const [menuToggle, setMenuToggle] = useState(true);
	const [refreshField, setRefreshField] = useState(false);
	const color = useTheme();

	useEffect(() => {
		if (!openFieldMenu) {
			setOpenFieldHistory(false);
			setMenuToggle(true);
		}
	}, [openFieldMenu]);

	//the toggle handling for the field menu...when adding more options, its refactor to use one state for all options time
	function handleToggleHistory() {
		setOpenFieldHistory(!openFieldHistory);
		setMenuToggle(!menuToggle);
	}

	function menuToggleHandler() {
		setMenuToggle(!menuToggle);
		setOpenFieldHistory(!openFieldHistory);
	}

	/**
	 * resets a field, by removing editing, and checking values to update values if they do not match
	 */

	async function handleRefreshField() {
		if (username && username !== authUsername) {
			removeUser();
		} else {
			const grabbedFieldInstance = await _getFieldInstance(currentFieldInstance.id);
			//we are grabbing the field instance from the cloud to see if the current value matches what we have saved in the DB- if it is, the field is up to date
			if (grabbedFieldInstance && grabbedFieldInstance.value !== currentFieldInstance.value) {
				handleUpdate(grabbedFieldInstance);
			}
		}
	}

	return (
		<>
			{refreshField && <RemoveUserModal open={refreshField} setOpen={setRefreshField} submitCb={handleRefreshField} />}
			<MoreHorizonButton
				colorPalette={color}
				handleToggleHistory={handleToggleHistory}
				handleRefreshField={() => setRefreshField(!refreshField)}
				style={{ borderLeft: "none" }}
			/>
			{openFieldHistory && fieldTemplate ? (
				<FieldHistory
					handleRevert={handleRevert}
					fieldTemplate={fieldTemplate}
					online={online}
					currentFieldInstance={currentFieldInstance}
					menuToggleHandler={menuToggleHandler}
					handleToggleHistory={handleToggleHistory}
				/>
			) : null}
		</>
	);
}

interface RemoveUserModalProps {
	open: boolean;
	setOpen: React.Dispatch<React.SetStateAction<boolean>>;
	submitCb: () => Promise<void>;
}

function RemoveUserModal(props: RemoveUserModalProps) {
	const { open, setOpen, submitCb } = props;

	const color = useTheme();

	async function submit() {
		setOpen(false);
		await submitCb();
	}

	return (
		<ConfirmationModal
			colorPalette={color}
			details="Are you sure you want to refresh the field? This will kick any active editor out of it"
			confirmTitle="Refresh Field"
			handleSubmit={submit}
			open={open}
			setOpen={setOpen}
			timeout={5000}
			canClose
		/>
	);
}

export default FieldMenu;
